import api from '@/api/api.js'
import api_config from '@/api/config/_api_config'

// KPI-001 : capacité signée « accueil:read » (120 s) demandée à be_config (rôle actif : Accueil, Caisse…),
// puis be_clinique avec l'en-tête. Le drapeau med_access_scoped évite qu'un refus de capacité ferme la session.
const options = token => ({ med_access_scoped: true, timeout: 20000, headers: { 'X-Accueil-Access': token } })

export default {
    async access() {
        const response = await api_config().post('/accueil/tableau-access', {}, { med_access_scoped: true, timeout: 20000 })
        if (!response.data.success || !response.data.data || !response.data.data.access_token) throw new Error('Accès au tableau des consultations indisponible.')
        return response.data.data
    },
    statistiques(data, token) {
        return api.clinique().post('/consultations/tableau-accueil/statistiques', data, options(token)).then(response => response.data)
    },
    liste(data, token) {
        return api.clinique().post('/consultations/tableau-accueil', data, options(token)).then(response => response.data)
    }
}
